import { type MaybeRefOrGetter, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useApi } from '@/composables/api'
import { assertSchema } from '@/helpers/schema'
import { User as userSchema } from '@/schemas/users'

const { sendGetRequest } = useApi()

export function useUserDetails(userId: MaybeRefOrGetter<string> | 'me') {
  return useQuery({
    queryKey: ['users', userId],
    staleTime: toValue(userId) === 'me' ? 60_000 : undefined,
    queryFn: async () => {
      const { data } = await sendGetRequest(`users/${toValue(userId)}`)

      assertSchema(data, userSchema)

      return data
    }
  })
}